function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { positionEnum } from "../../enums/positionEnum";
import ButtonAddon from "./ButtonAddon";
import Spin from "./Spin/Spin";
import { ButtonStyled, ButtonChildrenWrapper, ButtonText } from "./ButtonStyled";
var StyledSpin = styled(Spin).attrs(function (_ref) {
  var _theme$button;

  var theme = _ref.theme;
  return {
    color: theme === null || theme === void 0 ? void 0 : (_theme$button = theme.button) === null || _theme$button === void 0 ? void 0 : _theme$button.loading.color
  };
}).withConfig({
  displayName: "Button__StyledSpin",
  componentId: "sc-1bzfv6t-0"
})([""]);
export var Button = forwardRef(function (props, ref) {
  var isLoading = props.isLoading,
      children = props.children,
      before = props.before,
      after = props.after,
      _props$size = props.size,
      size = _props$size === void 0 ? 'large' : _props$size,
      icon = props.icon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      testId = props.testId,
      loadingTestId = props.loadingTestId,
      loader = props.loader,
      otherProps = _objectWithoutProperties(props, ["isLoading", "children", "before", "after", "size", "icon", "type", "testId", "loadingTestId", "loader"]);

  return React.createElement(ButtonStyled, _extends({
    "data-testid": testId
  }, _objectSpread({}, otherProps, {
    size: size,
    isLoading: isLoading,
    type: type,
    icon: icon,
    ref: ref
  })), React.createElement(StyledSpin, {
    show: isLoading,
    loadingTestId: loadingTestId,
    loader: loader
  }, React.createElement(ButtonChildrenWrapper, {
    hide: isLoading
  }, before && React.createElement(ButtonAddon, {
    size: size
  }, before), icon ? children : React.createElement(ButtonText, null, children), after && React.createElement(ButtonAddon, _extends({
    size: size
  }, {
    position: positionEnum.right
  }), after))));
});
Button.displayName = 'Button';
export default Button;